import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import {
  makeStyles,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  CircularProgress,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import Modal from './Modal';
import requestEndpoints from 'app/api/services/requestEndpoints';

import styles from './styles';
import moment from 'moment';
const useStyles = makeStyles(styles);

function Revisions(props) {
  const classes = useStyles();

  const request = useSelector(state => state.requests.details);

  const [revisionSelected, setRevisionSelected] = useState({});
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      try {
        const response = await requestEndpoints.getDiffRequest(request.cdSolicitacao);
        if (response.status === 200) {
          setRows(response.data);
        }
      } catch (error) {}
      setLoading(false);
    };
    init();
  }, [request.cdSolicitacao]);

  const handleClose = () => {
    setRevisionSelected({});
    setOpen(false);
  };

  const openModal = row => {
    setRevisionSelected(row);
    setOpen(true);
  };

  return (
    <>
      <Modal
        {...props}
        open={open}
        onClose={handleClose}
        revision={revisionSelected}
        request={request}
      />
      {loading && (
        <div className={classes.centerProgress}>
          <CircularProgress size={20} />
        </div>
      )}
      {!loading && (
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow className={classes.tableRow}>
              <TableCell className={classes.headTableCell} align="center">
                Nº Solicitação Anterior
              </TableCell>
              <TableCell className={classes.headTableCell} align="center">
                Tipo Serviço Anterior
              </TableCell>
              <TableCell className={classes.headTableCellDark} align="center">
                Nº Solicitação Atual
              </TableCell>
              <TableCell className={classes.headTableCellDark} align="center">
                Tipo Serviço Atual
              </TableCell>
              <TableCell className={classes.headTableCellDark} align="center">
                Data
              </TableCell>
              <TableCell className={classes.headTableCellDark} align="center"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow className={classes.tableRow}>
                <TableCell align="center" component="th" scope="row">
                  {row.nuSolicitacaoAnterior}
                </TableCell>
                <TableCell align="center">{row.nmServicoAnterior}</TableCell>
                <TableCell align="center">{row.nuSolicitacaoAtual}</TableCell>
                <TableCell align="center">{row.nmServicoAtual}</TableCell>
                <TableCell align="center">{moment.utc(row.dtAlteracao).format("DD/MM/YYYY")}</TableCell>
                <TableCell align="center">
                  <Button
                    color="primary"
                    className={classes.btnSigleAction}
                    size="small"
                    onClick={() => openModal(row)}
                  >
                    <AddIcon fontSize="inherit" /> Detalhes
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
}

export default injectIntl(Revisions);
